/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { showInfoToast } from "../../../components/CustomToast"
import EtcService from "../../../service/truckcontrol/Etc/etcService"
import { TETCDataPostReq } from "../../../service/truckcontrol/Etc/TEtc"
import { setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import DateInput from "../../../components/InputWrapper/DateInput"
import { get乗務員 as get乗務員Inner } from "../../../ts/util/haisyaUtil"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import stringUtil from "../../../ts/util/stringUtil"

/**
 * ETCデータ手入力モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const EtcRegisterModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  const disPatch: AppDispatch = useDispatch()

  //#region [state]
  const [乗務員ID, set乗務員ID] = useState<number>()
  const [社員コード, set社員コード] = useState<string>()
  const [日付, set日付] = useState<string | null>()
  const [車番, set車番] = useState<string>()
  const [金額, set金額] = useState<number | undefined>(0)
  const [備考, set備考] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    setAlertSource(undefined)
    try {
      const service = new EtcService()

      const reqData: TETCDataPostReq = {
        乗務員ID: 乗務員ID!,
        日付: 日付 ?? "",
        車番: 車番 ?? "",
        金額: 金額 ?? 0,
        備考,
      }
      const res = await service.post(reqData)
      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`ETCデータの登録が完了しました`)
        props.setIsEdited(true)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      props.setIsShow(false)
    }
  }

  //#endregion

  //#region [effect]

  /**
   * 乗務員フォーカスアウト時の動き
   */
  const get乗務員 = async (乗務員コード: string) => {
    try {
      return get乗務員Inner(乗務員コード)
    } catch (error) {
      disPatch(setAlerts(error))
    }
    return
  }

  const apply乗務員 = (乗務員?: TZyomuinListItem) => {
    if (乗務員 == null) {
      set乗務員ID(undefined)
      set社員コード("")
      set乗務員名("")
    } else {
      set乗務員ID(乗務員.乗務員ID)
      set社員コード(乗務員.社員コード)
      set乗務員名(乗務員.社員氏名)
    }
  }

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "現金払入力"}
      setIsShow={props.setIsShow}
      size={"lg"}
      footer={
        <Button
          type="submit"
          variant="waiting"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            beforeSubmit()
          }}>
          登録
        </Button>
      }>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Table className="form-table">
            <tbody>
              <tr>
                <th className="min-w-8rem">日付</th>
                <td>
                  <div style={{ width: "12rem" }}>
                    <DateInput
                      id="日付"
                      value={日付}
                      setValue={(v) => set日付(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">乗務員</th>
                <td>
                  <div className="input-group">
                    <TextInput
                      style={{ width: "6rem" }}
                      id="乗務員"
                      name="乗務員"
                      maxLength={4}
                      value={社員コード}
                      setValue={set社員コード}
                      onBlur={async (e) => {
                        if (!stringUtil.isNullOrWhiteSpace(社員コード)) {
                          const inner乗務員 = await get乗務員(社員コード!)
                          apply乗務員(inner乗務員)
                        } else {
                          apply乗務員(undefined)
                        }
                      }}
                    />
                    <button type="button" className="icon-button">
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}></FontAwesomeIcon>
                      </a>
                    </button>
                    <TextInput
                      style={{ width: "10rem" }}
                      id="担当乗務員名"
                      name="担当乗務員名"
                      isReadOnly={true}
                      value={乗務員名}
                      setValue={(v) => set乗務員名(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">車番</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <TextInput
                      id="車番"
                      name="車番"
                      value={車番}
                      setValue={(v) => set車番(v)}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">高速料</th>
                <td>
                  <div style={{ width: "8rem" }}>
                    <wjrInput.InputNumber
                      id="金額"
                      name="金額"
                      format={"n0"}
                      value={金額}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? set金額(c.value) : set金額(undefined)
                      }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th className="min-w-8rem">備考</th>
                <td>
                  <div style={{ width: "20rem" }}>
                    <TextInput
                      id="備考"
                      name="備考"
                      value={備考}
                      setValue={(v) => set備考(v)}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
      </Container>
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          set社員コード(乗務員.社員コード)
          set乗務員ID(乗務員.乗務員ID)
          set乗務員名(乗務員.社員氏名)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で登録しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default EtcRegisterModal
